/**
 * Dashboard Tabs — tab navigation for the home dashboard
 * @module features/home-dashboard/components/DashboardTabs
 */

import { AppTabs } from "@components/layout/AppTabs";
import { useDashboardTabs } from "@lib/tabs";

/**
 * Tabs for the dashboard — config-driven from DASHBOARD_TABS
 */
export function DashboardTabs() {
  const { tabs, isLoading, error } = useDashboardTabs();

  return <AppTabs tabs={tabs} isLoading={isLoading} error={error} componentName="DashboardTabs" />;
}

export default DashboardTabs;
